import React, { useCallback, useEffect } from "react";
import { useFetchPanelData } from "../../../features/dashboard/usePanelData";
import { checkHasData, parseStringArrayFields } from "../utils";

const StatusPanel = ({ chart }) => {
    const { panelObject, fetchPanelData } = useFetchPanelData(chart.dashboard, chart);
    const panelData = panelObject?.data;
    // const seconds = Math.max(chart.max_alive_seconds_delta || 10, 10);
    const seconds = 10;
    const panelId = chart?.unique_id || chart?.id;
    const chartType = chart?.chart_type || chart?.type;
    const dataTableId = chart?.data_table_id;
    const traceStatusFetch = useCallback((phase) => {
        if (process.env.NODE_ENV === "production") return;

        // eslint-disable-next-line no-console
        console.debug("[dashboard-panel-request]", {
            phase,
            panelId,
            chartType,
            data_table_id: dataTableId,
        });
    }, [chartType, dataTableId, panelId]);

    
    // actualización periódica de datos
    useEffect(() => {
        traceStatusFetch("status-initial-fetch");
        fetchPanelData(); // Initial fetch
        const interval = setInterval(() => {
            traceStatusFetch("status-periodic-fetch");
            fetchPanelData();
        }, seconds * 1000);
        
        return () => clearInterval(interval);
    }, [seconds, fetchPanelData, traceStatusFetch]);

    const hasData = checkHasData(panelData);

    const statusBooleanFields = parseStringArrayFields(chart.status_boolean_fields);
    const statusNumericFields = parseStringArrayFields(chart.status_number_fields);

    const rawDate = panelData?.[0]?.date;
    const parsedDate = rawDate ? new Date(rawDate) : null;
    const dateLabel = rawDate
        ? (parsedDate && !Number.isNaN(parsedDate.getTime())
              ? new Intl.DateTimeFormat("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: false,
                }).format(parsedDate)
              : String(rawDate))
        : null;

    return (
        <div className='status-panel'>
            <div className="status-panel__header">
                <h4 className="title cds--data-table-header__title">{chart.options?.title}</h4>

            </div>
            {chart.options?.subtitle && (
                <h5 className=" subtitle">{chart.options.subtitle}</h5>
            )}
            <h5 className=" subtitle">
                {chart.entity_value}{" "}{hasData ? "🟢" : "🔴"} {hasData && dateLabel && (
                    <span className="subtitle status-panel__date">{"(" + dateLabel + ")"}</span>
                )}
            </h5>
            <div className="status-panel__columns">
                {statusBooleanFields.length > 0 && (
                    <ul className={`status-panel__list${!hasData ? " faded" : ""}`}>
                        {statusBooleanFields.map((field, idx) => (
                            <li key={`${field}-${idx}`}>
                                <h6 className=" subtitle">
                                    {hasData
                                        ? `${field}: ${panelData[0][field] ? "🟢" : "🔴"}`
                                        : field}
                                </h6>
                            </li>
                        ))}
                    </ul>
                )}
                {statusNumericFields.length > 0 && (
                    <ul className={`status-panel__list${!hasData ? " faded" : ""}`}>
                        {statusNumericFields.map((field, idx) => (
                            <li key={`${field}-${idx}`}>
                                <h6 className=" subtitle">
                                    {hasData
                                        ? `${field}: ${panelData[0][field]}`
                                        : field}
                                </h6>
                            </li>
                        ))}
                    </ul>
                )}
            </div>            
        </div>
    );
};

export default React.memo(StatusPanel);
